<template>
  <div class="rcn-form">
    <Form
      @submit="onSubmit"
      :validation-schema="validationSchema"
      :initial-values="initialValues"
      class="rcn-form__content"
    >
      <hs-field name="name" type="text" label="Store Name" placeholder="Enter store name" :required="true" />
      <hs-field v-if="!requiresApproval" name="location" type="text" label="Location" placeholder="Enter store location" />
      <hs-field v-if="!requiresApproval" name="phone_number" type="text" label="Phone Number" placeholder="Enter store phone number" />

      <p>{{ requiresApproval ? "Name changes require approval and supporting documents because RRA EBM is activated." : "Store details will be saved directly. Supporting documents are not required." }}</p>
      <div v-if="requiresApproval" class="rcn-form__files">
        <div>
          <hs-file-upload
            v-model="rdb"
            title="RDB Certificate *"
            description="Upload your RDB certificate (required)"
            accept=".pdf,.jpg,.jpeg,.png"
            @change="handleRdbChange"
          />
          <p v-if="errors.rdb" class="rcn-form__file-error">{{ errors.rdb }}</p>
        </div>
        <div>
          <hs-file-upload
            v-model="otherFiles"
            title="Other Supporting Documents"
            description="Upload additional documents (optional, max 2)"
            accept=".pdf,.jpg,.jpeg,.png"
            :multiple="true"
            @change="handleOtherChange"
          />
        </div>
      </div>

      <hs-button type="submit" variant="primary" :loading="loading" class="rcn-form__submit">
        {{ requiresApproval ? 'Send Request' : 'Save Changes' }}
      </hs-button>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import { updateNameSchema } from "@/validations/updateSettings";
import { HsButton, HsFileUpload } from "@/components/ui";

export default {
  name: "RequestToChangeName",
  components: { Form, HsButton, HsFileUpload },
  props: {
    loading: { type: Boolean, default: false },
    requiresApproval: { type: Boolean, default: false },
  },
  emits: ["update-name", "close-modal"],
  data() {
    return {
      rdb: null,
      otherFiles: null,
      errors: { rdb: null },
    };
  },
  computed: {
    selectedStore() {
      const stores = this.$safeJSONParse(localStorage.getItem("stores")) || [];
      const selectedStore = this.$store.getters.getSelectedStore;
      const storeId = typeof selectedStore === "object" ? selectedStore?.id : selectedStore;
      return stores.find((store) => String(store.id) === String(storeId)) ||
        (typeof selectedStore === "object" ? selectedStore : null);
    },
    initialValues() {
      const store = this.selectedStore;
      return { name: store?.name || "", location: store?.location || "", phone_number: store?.phone_number || "" };
    },
    validationSchema() {
      return updateNameSchema;
    },
  },
  methods: {
    handleRdbChange(file) {
      this.rdb = Array.isArray(file) ? file[0] : file;
      this.errors.rdb = null;
    },
    handleOtherChange(files) {
      this.otherFiles = files;
    },
    onSubmit(values) {
      if (this.requiresApproval && !this.rdb) {
        this.errors.rdb = "Please upload RDB Certificate";
        return;
      }

      const details = Object.fromEntries(
        Object.entries(values).filter(([, value]) => value !== undefined && value !== null)
      );
      if (!this.requiresApproval) {
        this.$emit("update-name", details);
        return;
      }

      const otherArr = Array.isArray(this.otherFiles)
        ? this.otherFiles
        : this.otherFiles
          ? Array.from(this.otherFiles)
          : [];

      const allDocs = [this.rdb, ...otherArr.slice(0, 2)].filter(Boolean);

      const formData = new FormData();
      formData.append("store_id", this.selectedStore?.id);
      formData.append("name", details.name);
      allDocs.forEach((file) => formData.append("documents", file));

      this.$emit("update-name", formData);
    },
  },
};
</script>

<style scoped>
.rcn-form {
  padding: 0.5rem 0;
}

.rcn-form__content {
  display: grid;
  gap: 1.1rem;
}

.rcn-form__files {
  display: grid;
  gap: 0.85rem;
  grid-template-columns: 1fr 1fr;
}

@media (max-width: 560px) {
  .rcn-form__files {
    grid-template-columns: 1fr;
  }
}

.rcn-form__file-error {
  color: var(--hs-danger, #b91c1c);
  font-size: 0.78rem;
  margin-top: 0.35rem;
}

.rcn-form__submit {
  justify-self: end;
}
</style>
